// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import CustomerSummary from '@deere/cps-it.warranty-model-factory/lib/customer-summary';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import StatusChangeProduct from '@deere/cps-it.warranty-model-factory/lib/status-change-product';
import actions from '../../actions-list';
import {getDetails} from '../../shared/repositories';

export const updateProduct = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pin);

            const statusChangeProduct = new StatusChangeProduct({
                customerSummary: new CustomerSummary({
                    ...data.customerSummary
                }),
                dealer: new Dealer({
                    ...data.dealer
                }),
                model: data.model,
                pin: data.pin,
                pip: data.pip,
                pipIndicator: data.pipIndicator
            });

            dispatch({
                data,
                type: actions.UPDATE_STATUS_CHANGE_REQUEST_PRODUCT_DETAILS
            });

            dispatch({
                statusChangeProduct,
                type: actions.UPDATE_STATUS_CHANGE_PRODUCT_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/product.js